import React, { Component, Fragment } from 'react';
// import PropTypes from 'prop-types';
import { Message, Progress, Button } from 'semantic-ui-react';
import { withLocalize } from 'react-localize-redux';
import UploadButton from './UploadButton';
import ImageCropper from './ImageCropper';

class FileManager extends Component {
  handleBtnClick = async () => {
    const { acceptedFile, isImage, handleUploadBtnClick } = this.props;

    let file = null;
    if (isImage && this.imgCropper) {
      file = await this.imgCropper.getCroppedImg();
    }
    handleUploadBtnClick(file || acceptedFile);
  };

  render() {
    const {
      acceptedFile,
      rejectedFile,
      error,
      isImage,
      handleUploadBtnClick,
      handleReset,
      cropRatios,
      percentCompleted,
      translate,
      isUploading
    } = this.props;

    return (
      <Fragment>
        {!!rejectedFile && (
          <Message negative>
            <Message.Content>
              {rejectedFile.name} is rejected - {error}
            </Message.Content>
          </Message>
        )}

        {!!acceptedFile &&
          !isImage && (
          <div className='reactModal_message'>
            <i className='fal fa-file-check reactModal_message_icon' />
            {acceptedFile.name} - {acceptedFile.size} bytes
          </div>
        )}

        {!!acceptedFile &&
          isImage && (
          <ImageCropper
            onRef={imgCropper => {
              this.imgCropper = imgCropper;
            }}
            handleUploadBtnClick={handleUploadBtnClick}
            file={acceptedFile}
            cropRatios={cropRatios}
          />
        )}

        {percentCompleted ? (
          <Progress percent={percentCompleted} progress='percent' indicating />
        ) : (
          <Fragment>
            {!!acceptedFile && (
              <UploadButton disabled={isUploading} onClick={this.handleBtnClick}>
                {translate('uploader.button.upload')}
              </UploadButton>
            )}

            <Button
              type='button' basic disabled={isUploading}
              onClick={handleReset}
            >
              {translate('uploader.button.clear')}
            </Button>
          </Fragment>
        )}
      </Fragment>
    );
  }
}

export default withLocalize(FileManager);



// WEBPACK FOOTER //
// ./src/components/uploader/FileManager.js